<template>
  <div
    class="pill"
    :class="classes()"
    :style="styles()"
  />
</template>

<script>
import { randomIntBetween } from '@/utilities/random';

const colorClasses = {
  mediumBlue: 'pill-medium-blue',
  paleBlue: 'pill-pale-blue',
  indigo: 'pill-indigo',
  purple: 'pill-purple',
  gold: 'pill-gold',
  tangerine: 'pill-tangerine'
};

const heightClasses = {
  short: 'pill-short',
  medium: 'pill-medium',
  tall: 'pill-tall-1',
  xtall: 'pill-tall-2',
  xxtall: 'pill-tall-3',
  xxxtall: 'pill-tall-4'
};

const offsetClasses = {
  '-1': 'pill-offset-negative',
  0: 'pill-offset-0',
  1: 'pill-offset-1',
  2: 'pill-offset-2',
  3: 'pill-offset-3',
  4: 'pill-offset-4'
};

const animationNames = {
  normal: 'fadeinout',
  slow: 'fadeinout-slow',
  fast: 'fadeinout-quick'
};

export default {
  name: 'Pill',
  props: {
    random: Boolean,
    color: {
      type: String,
      validator: function (value) {
        return Object.keys(colorClasses).includes(value);
      }
    },
    height: {
      type: String,
      validator: function (value) {
        return Object.keys(heightClasses).includes(value);
      }
    },
    offset: {
      type: Number,
      validator: function (value) {
        return (
          Object
            .keys(offsetClasses)
            .map((offsetClass) => parseInt(offsetClass, 10))
            .includes(value)
        );
      }
    },
    overflow: Boolean,
    density: Number,
    randomAnimationDelay: Boolean
  },
  methods: {
    classes () {
      return {
        [this.colorClass()]: true,
        [this.heightClass()]: true,
        [this.offsetClass()]: true,
        'pill--overflow': this.overflow
      };
    },
    styles () {
      return {
        ...(
          this.randomAnimationDelay && (
            {
              animationDelay: this.randomAnimationDelayStyle(),
              animationName: this.randomAnimationNameStyle()
            }
          )
        )
      };
    },
    colorClass () {
      return (
        this.random
          ? this.randomColorClass()
          : colorClasses[this.color]
      );
    },
    heightClass () {
      return (
        this.random
          ? this.randomHeightClass()
          : heightClasses[this.height]
      );
    },
    offsetClass () {
      return (
        this.random
          ? this.randomOffsetClass()
          : offsetClasses[this.offset ?? 0]
      );
    },
    randomColorClass () {
      const classes = Object.values(colorClasses);
      return classes[randomIntBetween(0, (classes.length - 1))];
    },
    randomHeightClass () {
      const classes = Object.values(heightClasses);
      return (
        classes[
          Math.floor(
            (this.density / 100) *
            randomIntBetween(0, classes.length)
          )
        ]
      );
    },
    randomOffsetClass () {
      const classes = Object.values(offsetClasses);
      const options = (
        this.row === 1
          ? classes
          : (
            classes.filter(
              (offsetClass) => (
                offsetClass !== 'pill-offset-negative'
              )
            )
          )
      );
      return options[randomIntBetween(0, options.length)];
    },
    randomAnimationDelayStyle () {
      const options = (
        [...Array(8).keys()].map((delay) => delay / 4)
      );
      return (
        `${options[randomIntBetween(0, options.length)]}s`
      );
    },
    randomAnimationNameStyle () {
      const names = Object.values(animationNames);
      return names[randomIntBetween(0, names.length)];
    }
  }
};
</script>>
